import { createSlice } from "@reduxjs/toolkit";
import { STATUS } from "../constant";

const initialState = {
	hospitals: {
		status: STATUS.IDLE,
		data: null,
	},
	staticContent: {
		status: STATUS.IDLE,
		data: null,
	},
};

export const dataSlice = createSlice({
	name: "content",
	initialState,
	reducers: {
		getHospitals(state, _action) {
			state.hospitals.status = STATUS.REQUEST;
			state.hospitals.data = null;
		},
		getHospitalSuccess(state, action) {
			state.hospitals.data = action.payload.hospitals;
			state.hospitals.status = STATUS.SUCCESS;
		},
		getHospitalFailure(state, action) {
			state.hospitals.data = action.payload.hospitals;
			state.hospitals.status = STATUS.FAILED;
		},
		getStaticContent(state, _action) {
			state.staticContent.status = STATUS.REQUEST;
			state.staticContent.data = null;
		},
		getStaticContentSuccess(state, action) {
			state.staticContent.data = action.payload;
			state.staticContent.status = STATUS.SUCCESS;
		},
		getStaticContentFailure(state, action) {
			state.staticContent.data = action.payload;
			state.staticContent.status = STATUS.FAILED;
		},
	},
});

export const {
	getHospitals,
	getHospitalSuccess,
	getHospitalFailure,
	getStaticContent,
	getStaticContentSuccess,
	getStaticContentFailure,
} = dataSlice.actions;

export default dataSlice.reducer;
